import React, { useContext } from 'react';
import classNames from 'classnames';
import { CloseOutlined as MenuIconOpen } from 'jl-design-system/components/icons/CloseOutlined';
import { MenuOutlined as MenuIconClosed } from 'jl-design-system/components/icons/MenuOutlined';

import { AccountLinks } from '../account-links/AccountLinks';
import { Basket } from '../basket/Basket';
import { StoreFinderIcon } from '../store-finder-icon/StoreFinderIcon';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';

import styles from './user-tools.scss';
interface UserToolsProps {
  isMenuOpen: boolean;
  onMenuButtonClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isTypeaheadOpen?: boolean;
}

export const UserTools = ({
  isMenuOpen,
  onMenuButtonClick,
  isTypeaheadOpen = false,
}: UserToolsProps) => {
  const { features } = useContext(EnvVarsFeaturesContext);

  const shouldHideBasket = features.mvoMode || features.hideBasketIcon;

  return (
    <nav
      data-testid="user-tools-nav"
      className={classNames(styles.nav, {
        [styles.hidden]: isTypeaheadOpen,
      })}
    >
      <ul className={styles.navList}>
        <li className={styles.hideOnLg}>
          <StoreFinderIcon />
        </li>

        <AccountLinks lgOnlyClassname={styles.lgOnly} />
        {!shouldHideBasket && (
          <li>
            <Basket />
          </li>
        )}
        <li className={styles.hideOnLg} data-testid="menu-icon">
          <a
            id="mobile-menu-toggle"
            href="/menu"
            data-testid="nav-link--menu"
            onClick={onMenuButtonClick}
            role="button"
            aria-label={isMenuOpen ? 'Close Menu' : 'Open Menu'}
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation-menu"
          >
            <span className={styles.visuallyHidden}>
              {isMenuOpen ? 'Close' : 'Menu'}
            </span>

            {isMenuOpen ? (
              <MenuIconOpen
                className={styles.icon}
                dataTestId="nav-menu-close-icon"
                size="large"
                title="Close Menu"
              />
            ) : (
              <MenuIconClosed
                className={styles.icon}
                dataTestId="nav-menu-icon"
                size="large"
                title="Open Menu"
              />
            )}
          </a>
        </li>
      </ul>
    </nav>
  );
};
